//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../../media/MediaQuery";

//css
import styled from "styled-components";
// component
import MyPageProduct from "../../../../component/content/MyPageProduct";
import Pagination from "../../../../component/pagination/Pagination";
import BasicBtn from "../../../../component/button/BasicBtn";
// img
import date from "../../../../assets/img/icon/date.svg";
import product from "../../../../assets/img/picture/product_01.jpg";
import more from "../../../../assets/img/icon/icon_more2.svg";

// responsive
import { M, T } from "../../../../utils/MT";

// testData
import { orderStateDataList } from "../../../../Data";

export default function MyCancel(props) {
    //페이지 이동
    const navigate = useNavigate();
    const cancelDetailPage = () => {
        navigate(`/mypage/cancel_detail`);
    };

    return (
        <Wrap>
            {/* 타이틀 */}
            <MyPageTitleBox>
                <MyPageTitle>취소/교환/반품</MyPageTitle>
            </MyPageTitleBox>

            {/* 확인 버튼 */}
            <CancelBtnWrap>
                <DateBtnList>
                    <DateBtn active>최근 1개월</DateBtn>
                    <DateBtn>최근 3개월</DateBtn>
                    <DateBtn>최근 1년</DateBtn>
                </DateBtnList>

                <DateCalendarWrap>
                    <DateCalendar type="date" required />
                    <Border>-</Border>
                    <DateCalendar type="date" required />

                    <DateCheckBtn>
                        조회
                        {/* <BasicBtn text="" gray={true} black={true} /> */}
                    </DateCheckBtn>
                </DateCalendarWrap>
            </CancelBtnWrap>

            {/* 테이블 처리 */}
            <CancelTableWrap>
                <PC>
                    <CancelTableList>
                        <CancelTitle>신청일</CancelTitle>
                        <CancelTitle>주문번호</CancelTitle>
                        <CancelTitle>유형</CancelTitle>
                        <CancelTitle>주문내역</CancelTitle>
                        <CancelTitle>진행상황</CancelTitle>
                    </CancelTableList>
                </PC>
                <CancelContentWrap>
                    {/* 취소/교환/반품 내역이 없을때 */}
                    {/* <NotCancelText>취소/교환/반품 내역이 없습니다.</NotCancelText> */}
                    {orderStateDataList.map((list, index) => {
                        return (
                            <CancelContent
                                key={index}
                                onClick={() => {
                                    cancelDetailPage();
                                }}
                            >
                                <CancelNumListWrap>
                                    <CancelContentList>{list.date}</CancelContentList>
                                    <CancelContentList>
                                        {list.num}
                                        <MoreBtn>
                                            <img src={more} alt="화살표 아이콘" />
                                        </MoreBtn>
                                    </CancelContentList>
                                </CancelNumListWrap>

                                <PC>
                                    <CancelContentState>{list.state}</CancelContentState>
                                </PC>
                                <CancelStateListWrap>
                                    {list.isItem.map((item, index) => {
                                        return (
                                            <CancleItemList key={"isItem" + index}>
                                                <MyPageProduct
                                                    id={item.id}
                                                    productImg={item.productImg}
                                                    itemName={item.itemName}
                                                    price={item.price}
                                                    num={item.num}
                                                    option={item.option}
                                                    i={item.id}
                                                />

                                                <Mobile>
                                                    <CancelContentState>{list.state}</CancelContentState>
                                                </Mobile>

                                                <CancelContentOrderState>{item.orderstate}</CancelContentOrderState>
                                            </CancleItemList>
                                        );
                                    })}
                                </CancelStateListWrap>
                            </CancelContent>
                        );
                    })}
                </CancelContentWrap>
            </CancelTableWrap>

            {/* 페이징 */}
            <MyPageTabelWrap>
                <Pagination />
            </MyPageTabelWrap>
        </Wrap>
    );
}

const Wrap = styled.section`
    position: relative;
    width: 100%;

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;
    }
`;

const MyPageTitleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const MyPageTitle = styled.p`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }
    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;

const MyPageTabelWrap = styled.div`
    margin-top: calc(100vw * (80 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (80 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(80)};
    }
`;
const CancelBtnWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin: calc(100vw * (20 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;
        margin: ${M(30)} 0;
    }
`;
const DateBtnList = styled.div`
    @media screen and (max-width: 900px) {
        width: 100%;
    }
`;
const DateBtn = styled.button`
    width: calc(100vw * (110 / 1920));
    height: calc(100vw * (35 / 1920));
    margin-right: calc(100vw * (10 / 1920));
    font-size: calc(100vw * (11 / 1920));

    border: 1px solid #dddddd;
    border-radius: 4px;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (110 / 1300));
        height: calc(100vw * (35 / 1300));
        margin-right: calc(100vw * (10 / 1300));
        font-size: calc(100vw * (11 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(120)};
        height: ${M(35)};
        margin-right: ${M(9)};
        font-size: ${M(11)};

        &:last-child {
            margin-right: 0;
        }
    }

    ${({ active }) => {
        return (
            active &&
            `
            color: var(--main-color);
            border-color: var(--main-color);
        `
        );
    }}
`;
const DateCalendarWrap = styled.div`
    display: flex;
    align-items: center;

    @media screen and (max-width: 900px) {
        width: 100%;
        margin-top: ${M(21)};
    }
`;
const Border = styled.p`
    width: calc(100vw * (8 / 1920));
    margin: 0 calc(100vw * (8 / 1920));
    color: #aaaaaa;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (8 / 1300));
        margin: 0 calc(100vw * (8 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(8)};
        margin: 0 ${M(4)};
    }
`;
const DateCalendar = styled.input`
    position: relative;
    flex-basis: 50%;

    width: calc(100vw * (117 / 1920));
    height: calc(100vw * (35 / 1920));
    padding: calc(100vw * (8 / 1920));

    border: 1px solid #dddddd;
    border-radius: 4px;

    font-size: calc(100vw * (13 / 1920));
    color: #8c8c8c;

    &[type="date"]::-webkit-clear-button,
    &[type="date"]::-webkit-inner-spin-button {
        display: none;
    }
    &[type="date"]::-webkit-calendar-picker-indicator {
        background: transparent;
        z-index: 1;
    }

    &::after {
        position: absolute;
        top: 50%;
        right: calc(100vw * (6 / 1920));
        content: "";
        width: calc(100vw * (20 / 1920));
        height: calc(100vw * (20 / 1920));

        background: #fff url(${date}) no-repeat center center / contain;
        transform: translateY(-50%);
        z-index: 0;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (117 / 1300));
        height: calc(100vw * (35 / 1300));
        padding: calc(100vw * (8 / 1300));

        font-size: calc(100vw * (13 / 1300));

        &::after {
            right: calc(100vw * (6 / 1300));
            width: calc(100vw * (20 / 1300));
            height: calc(100vw * (20 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(117)};
        height: ${M(35)};
        padding: ${M(8)};
        font-size: ${M(13)};

        &::after {
            right: ${M(6)};
            width: ${M(20)};
            height: ${M(20)};
        }
    }
`;
const DateCheckBtn = styled.button`
    display: inline-block;
    width: calc(100vw * (72 / 1920));
    height: calc(100vw * (35 / 1920));
    font-size: calc(100vw * (11 / 1920));

    margin-left: calc(100vw * (15 / 1920));

    border: 1px solid #dddddd;
    border-radius: 4px;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (72 / 1300));
        height: calc(100vw * (35 / 1300));
        font-size: calc(100vw * (11 / 1300));

        margin-left: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        min-width: ${M(120)};
        height: ${M(35)};
        margin-left: ${M(8)};
        font-size: ${M(11)};

        & p {
            font-size: ${M(11)};
        }
    }
`;
const CancelTableWrap = styled.div``;
const CancelTableList = styled.div`
    display: flex;
    align-items: center;

    padding: calc(100vw * (20 / 1920)) 0;

    border-top: 1px solid #222222;
    border-bottom: 1px solid #dddddd;

    & > div:nth-child(1) {
        width: calc(100vw * (100 / 1920));
    }
    & > div:nth-child(2) {
        width: calc(100vw * (150 / 1920));
    }
    & > div:nth-child(3) {
        width: calc(100vw * (125 / 1920));
    }
    & > div:nth-child(4) {
        width: calc(100vw * (380 / 1920));
    }
    & > div:nth-child(5) {
        width: calc(100vw * (75 / 1920));
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;

        & > div:nth-child(1) {
            width: calc(100vw * (100 / 1300));
        }
        & > div:nth-child(2) {
            width: calc(100vw * (150 / 1300));
        }
        & > div:nth-child(3) {
            width: calc(100vw * (125 / 1300));
        }
        & > div:nth-child(4) {
            width: calc(100vw * (380 / 1300));
        }
        & > div:nth-child(5) {
            width: calc(100vw * (75 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        padding: ${M(20)} 0;

        & > div:nth-child(1) {
            width: auto;
        }
        & > div:nth-child(2) {
            width: 100%;
        }
        & > div:nth-child(3) {
            width: auto;
        }
        & > div:nth-child(4) {
            width: auto;
        }
        & > div:nth-child(5) {
            width: auto;
        }
    }
`;
const CancelTitle = styled.div`
    text-align: center;
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};
    }
`;
const CancelContent = styled.li`
    display: flex;
    align-items: center;

    padding: calc(100vw * (30 / 1920)) 0;
    border-bottom: 1px solid #dddddd;

    cursor: pointer;

    & > * {
        flex-shrink: 0;
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (30 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;

        padding: 0;
        margin-bottom: ${M(20)};
    }
`;
const CancelNumListWrap = styled.div`
    display: flex;

    & > p:nth-child(1) {
        width: calc(100vw * (100 / 1920));
    }
    & > p:nth-child(2) {
        width: calc(100vw * (150 / 1920));
    }

    @media screen and (max-width: 1300px) {
        /* & > p:nth-child(1) {
            width: auto;
        }
        & > p:nth-child(2) {
            width: auto;
        } */

        & > p:nth-child(1) {
            width: calc(100vw * (100 / 1300));
        }
        & > p:nth-child(2) {
            width: calc(100vw * (150 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        justify-content: space-between;
        padding: ${M(16)} 0;

        border-top: 1px solid #000000;
        border-bottom: 1px solid #ddd;

        & > p:nth-child(1) {
            width: ${M(100)};
        }
        & > p:nth-child(2) {
            position: relative;
            /* width: ${M(150)}; */
            width: auto;
        }
    }
`;

const MoreBtn = styled.span`
    display: none;

    & img {
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 900px) {
        display: flex;
        align-items: center;

        width: ${M(10)};
        height: ${M(12)};
        margin-left: ${M(13)};
    }
`;

const CancelStateListWrap = styled.ul`
    width: calc(100vw * (455 / 1920));
    @media screen and (max-width: 1300px) {
        width: calc(100vw * (455 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        /* width: 100%;
        flex-wrap: wrap;
        padding: ${M(20)} ${M(20)} ${M(20)} 0;
        border-top: 1px solid #dddddd;

        & li {
            order: 1;
            width: 100%;
        }
        & p:nth-child(3) {
        } */
    }
`;
const CancleItemList = styled.li`
    display: flex;
    align-items: center;

    & > div {
        width: calc(100vw * (380 / 1920));
    }

    &:not(:first-child) {
        border-top: 1px solid #ddd;
        margin-top: calc(100vw * (30 / 1920));
        padding-top: calc(100vw * (30 / 1920));
    }

    @media screen and (max-width: 1300px) {
        & > div {
            width: calc(100vw * (380 / 1300));
        }

        &:not(:first-child) {
            margin-top: calc(100vw * (30 / 1300));
            padding-top: calc(100vw * (30 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;
        padding: ${M(20)} 0 ${M(30)};
        /* width: 100%;
        flex-wrap: wrap;
        padding: ${M(20)} ${M(20)} ${M(20)} 0;
        border-top: 1px solid #dddddd; */
        & > div {
            width: 100%;
        }
        &:not(:first-child) {
            margin-top: 0;
            padding-top: ${M(20)};
        }
    }
`;
const CancelContentList = styled.p`
    text-align: center;
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        display: flex;
        align-items: center;

        font-size: ${M(14)};

        text-align: left;
    }
`;
const CancelContentState = styled(CancelContentList)`
    width: calc(100vw * (125 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (125 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        padding-left: ${M(98)};

        margin-top: ${M(10)};
    }
`;
const CancelContentOrderState = styled(CancelContentList)`
    width: calc(100vw * (75 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (75 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;

        order: 3;
        width: auto;
        margin-left: auto;

        margin-top: ${M(40)};
        font-size: ${M(16)};
        text-align: right;
        font-family: "Noto-B";
    }
`;
const NotCancelText = styled.p`
    margin: calc(100vw * (150 / 1920)) 0;
    font-size: calc(100vw * (15 / 1920));

    text-align: center;
    color: #aaaaaa;

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (150 / 1300)) 0;
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin: ${M(150)} 0;
        font-size: ${M(15)};
    }
`;
const CancelContentWrap = styled.ul``;
